export const FETCH_STATUS = 'FETCH_STATUS';
export const GET_PROVIDERS = 'GET_PROVIDERS';
export const GET_VERSION = 'GET_VERSION';
export const GET_CONFIG_FOR_REMOTE = 'GET_CONFIG_FOR_REMOTE';
export const GET_REMOTE_LIST = 'GET_REMOTE_LIST';
export const GET_CONFIG_DUMP = 'GET_CONFIG_DUMP';
export const GET_FILES_LIST = 'GET_FILES_LIST';
export const CHANGE_PATH = 'CHANGE_PATH';
export const CREATE_PATH = 'CREATE_PATH';
export const REMOVE_PATH = 'REMOVE_PATH';
export const CHANGE_REMOTE_NAME = 'CHANGE_REMOTE_NAME';
export const CHANGE_REMOTE_PATH = 'CHANGE_REMOTE_PATH';
export const NAVIGATE_UP = 'NAVIGATE_UP';
export const NAVIGATE_FWD = 'NAVIGATE_FWD';
export const NAVIGATE_BACK = 'NAVIGATE_BACK';
export const CHANGE_VISIBILITY_FILTER = 'CHANGE_VISIBILITY_FILTER';
export const CHANGE_GRID_MODE = 'CHANGE_GRID_MODE';
export const SIGNOUT_REQUEST = 'SIGNOUT_REQUEST';
export const CHANGE_SEARCH_QUERY = 'CHANGE_SEARCH_QUERY';
export const GET_REMOTE_ABOUT = 'GET_REMOTE_ABOUT';
export const CREATE_PUBLIC_LINK = 'CREATE_PUBLIC_LINK';
export const GET_RUNNING_JOBS = 'GET_RUNNING_JOBS';
export const GET_STATUS_FOR_RUNNING_JOB = 'GET_STATUS_FOR_RUNNING_JOB';
export const SET_BANDWIDTH = 'SET_BANDWIDTH';
export const GET_BANDWIDTH = 'GET_BANDWIDTH';
export const ENABLE_STATUS_CHECK = 'ENABLE_STATUS_CHECK';
// export const CHANGE_USER_NAME_PASSWORD = 'CHANGE_USER_NAME_PASSWORD';
export const CHANGE_AUTH_KEY = 'CHANGE_AUTH_KEY';
export const CHANGE_IP_ADDRESS = 'CHANGE_IP_ADDRESS';
export const CHANGE_AXIOS_INTERCEPTOR = 'CHANGE_AXIOS_INTERCEPTOR';
export const CHANGE_LOAD_IMAGES = 'CHANGE_LOAD_IMAGES';
export const LOAD_IMAGE = 'LOAD_IMAGE';
export const CHANGE_LAYOUT_COLS = 'CHANGE_LAYOUT_COLS';
export const ADD_LAYOUT_CONTAINER = 'ADD_LAYOUT_CONTAINER';
export const REMOVE_LAYOUT_CONTAINER = 'REMOVE_LAYOUT_CONTAINER';
export const CHANGE_ACTIVE_REMOTE_CONTAINER = 'CHANGE_ACTIVE_REMOTE_CONTAINER';
export const CHANGE_DISTRACTION_FREE_MODE = "CHANGE_DISTRACTION_FREE_MODE";
export const CHANGE_SORT_FILTER = "CHANGE_SORT_FILTER";


export const GET_MOUNT_LIST = "GET_MOUNT_LIST";
export const REMOVE_MOUNT = "REMOVE_MOUNT";
export const CREATE_MOUNT = "CREATE_MOUNT";

export const REQUEST_ERROR = 'ERROR';
export const REQUEST_SUCCESS = 'SUCCESS';
export const REQUEST_LOADING = 'LOADING';
